import React from "react";
import styled from "styled-components";
import theme from "../../../styles/theme";
import headingStyles from "./headingStyles";

const {
	colors,
	breakPoints: { mobileFirstScreenQuery },
} = theme;

export const style = (props) => `  
  font-family: ${theme.font.recoletaMedium};
  font-size: 34px;
  line-height: 36px;

  ${mobileFirstScreenQuery.medium} {
    font-size: 44px;
    line-height: 46px;
  }

}`;

const H2 = styled.h2(headingStyles, (props) => style(props));

export default ({ children, ...props }) => <H2 {...props}>{children}</H2>;
